import product from "./api/Products.Service";
import category from "./api/Category.Service";

export default {
  product,
  category
};
